"use strict";

exports.__esModule = true;
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = require("prop-types");

var _styledComponents = _interopRequireDefault(require("styled-components"));

var _Input = _interopRequireDefault(require("../Input"));

var _Select = _interopRequireDefault(require("../Select"));

var _Option = _interopRequireDefault(require("../Select/Option"));

var _months = _interopRequireDefault(require("./months.json"));

var _getDayValue = _interopRequireDefault(require("./utils/getDayValue"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

function _templateObject2() {
  var data = _taggedTemplateLiteralLoose(["\n\twhite-space: nowrap;\n"]);

  _templateObject2 = function _templateObject2() {
    return data;
  };

  return data;
}

function _templateObject() {
  var data = _taggedTemplateLiteralLoose(["\n\twidth: 60px !important;\n"]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}

function _taggedTemplateLiteralLoose(strings, raw) { if (!raw) { raw = strings.slice(0); } strings.raw = raw; return strings; }

var DayInput = (0, _styledComponents.default)(_Input.default)(_templateObject());
DayInput.displayName = 'DayInput';

var Container = _styledComponents.default.span(_templateObject2());

Container.displayName = 'Container';

var DayMonthInput = function DayMonthInput(_ref) {
  var onChange = _ref.onChange,
      value = _ref.value,
      name = _ref.name,
      gaAction = _ref.gaAction,
      id = _ref.id,
      props = _objectWithoutPropertiesLoose(_ref, ["onChange", "value", "name", "gaAction", "id"]);

  var onChanges = function onChanges(e) {
    var _onChange;

    value[e.target.name] = e.target.value;
    value.day = (0, _getDayValue.default)(value.day, value.month);
    onChange((_onChange = {}, _onChange[name] = value, _onChange));
  };

  return _react.default.createElement(Container, {
    "data-e2e": "day-month-input-" + id
  }, _react.default.createElement(DayInput, _extends({}, props, {
    type: "number",
    name: "day",
    "data-track-action": gaAction + " day",
    "data-track-value": "on",
    onChange: onChanges,
    min: "1",
    max: "31",
    step: "1",
    value: value.day
  })), "\xA0", _react.default.createElement(_Select.default, _extends({}, props, {
    name: "month",
    gaAction: gaAction + " month",
    gaTrackValue: true,
    value: value.month,
    onChange: onChanges
  }), _months.default.map(function (month) {
    return _react.default.createElement(_Option.default, {
      key: month.label,
      value: month.value
    }, month.label);
  })));
};

DayMonthInput.displayName = 'DayMonthInput';
DayMonthInput.propTypes = {
  value: (0, _propTypes.shape)({
    day: (0, _propTypes.oneOfType)([_propTypes.number, _propTypes.string]),
    month: (0, _propTypes.oneOfType)([_propTypes.number, _propTypes.string])
  }).isRequired,
  onChange: _propTypes.func.isRequired,
  name: _propTypes.string.isRequired,
  gaAction: _propTypes.string,
  id: _propTypes.string
};
DayMonthInput.defaultProps = {
  gaAction: '',
  id: ''
};
var _default = DayMonthInput;
exports.default = _default;